<template>
	<el-tabs id="userinfoList" value="first" type="border-card">
		<el-tab-pane name="first" :label="$t('projectInfo')">
			<el-row>
				<el-col :xs="24">
          <el-form :model="projectForm" :rules="rules" ref="projectForm" label-width="200px">
					  <el-card >
							<el-row>
                <el-col style="text-align: right;" :xs="24" :md="24">
                  <el-button v-has="{class:'projectTask'}" v-if="flagStatus=='0'&&taskQty!='0'" size="mini" type="primary" @click="addTask">{{$t('addTask')}}</el-button>
                </el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('businessCategory1')" prop="businessCategory">
                    <el-select v-model="projectForm.businessCategory" disabled>
											<el-option v-for="item in BusinessCategoryList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectType1')" prop="projectType" >
										<el-select v-model="projectForm.projectType" disabled>
											<el-option v-for="item in ProjectTypeList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('country1')" prop="country" >
                    <el-select filterable v-model="projectForm.country" disabled>
											<el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectName1')" prop="projectName">
										<el-input v-model="projectForm.projectName" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('upstreamSystemId1')" >
                    <el-input v-model="projectForm.upstreamSystemId" disabled/>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('ipmsProjectCode1')" >
										<el-input v-model="projectForm.ipmsProjectCode" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectManager1')" prop="projectManager" >
                    <el-select v-model="projectForm.projectManager" disabled>
                      <el-option v-for="item in ProjectManagerList" :key="item.empCode" :label="item.userCode" :value="item.empCode"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deputyProjectManager1')">
                    <el-select v-model="projectForm.deputyProjectManager" disabled>
                      <el-option v-for="item in DeputyManagerList" :key="item.empCode" :label="item.userCode" :value="item.empCode"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('department1')" prop="department">
                    <el-select filterable v-model="projectForm.department" disabled>
											<el-option v-for="item in DeptList" :key="item.deptCode" :label="item.deptEnName" :value="item.deptCode"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('industry1')" prop="industry">
                    <el-select filterable v-model="projectForm.industry" disabled>
											<el-option v-for="item in IndustryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectStatus1')" prop="projectStatus" >
                    <el-select v-model="projectForm.projectStatus" disabled>
											<el-option v-for="item in StatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('projectLevel1')" prop="projectLevel">
										<el-select filterable v-model="projectForm.projectLevel" disabled>
											<el-option v-for="item in ProjectLevelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectStartDate1')" prop="projectStartDate">
										<el-date-picker v-model="projectForm.projectStartDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectEndDate1')" prop="projectEndDate">
										<el-date-picker v-model="projectForm.projectEndDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectEstimatedEndDate1')" prop="projectEstimatedEndDate" >
										<el-date-picker v-model="projectForm.projectEstimatedEndDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectActualEndDate1')" prop="projectActualEndDate">
										<el-date-picker v-model="projectForm.projectActualEndDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
									</el-form-item>
								</el-col>
              </el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('beneficialDept1')" prop="beneficialDept">
                    <!-- <el-select filterable v-model="projectForm.beneficialDept" disabled>
											<el-option v-for="item in BeneficialDeptList" :key="item.deptCode" :label="item.deptName" :value="item.deptCode"></el-option>
										</el-select> -->
                    <el-cascader v-model="projectForm.beneficialDept" :options="BeneficialDeptList" :props="optionProps" :change-on-select="true" disabled></el-cascader>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('finalBeneficialDept1')" prop="finalBeneficialDept">
                    <el-input v-model="projectForm.finalBeneficialDept" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('salesMan1')" >
										<el-input v-model="projectForm.salesMan" disabled/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('salesRegion1')">
										<el-input v-model="projectForm.salesRegion" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('presaleKeyProject1')" prop="presaleKeyProject" >
                    <el-select v-model="projectForm.presaleKeyProject" disabled>
											<el-option v-for="item in PresaleKeyProjectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('postsaleKeyProject1')" >
                    <el-select v-model="projectForm.postsaleKeyProject" disabled>
											<el-option v-for="item in PostsaleKeyProjectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('beltAndRoad1')" prop="beltAndRoad" >
                    <el-select v-model="projectForm.beltAndRoad" disabled>
											<el-option v-for="item in BeltAndRoadList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subcontractor1')" >
										<el-input v-model="projectForm.subcontractor" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('businessType1')" >
                    <el-select filterable v-model="projectForm.businessType" disabled>
											<el-option v-for="item in BusinessTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryType1')" >
                    <el-select filterable v-model="projectForm.deliveryType" disabled>
											<el-option v-for="item in DeliveryTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row v-if="projectForm.projectType == 'MST'">
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('testLeader1')">
                    <el-select v-model="projectForm.testLeader" disabled>
                      <el-option v-for="item in TestLeaderList" :key="item.empCode" :label="item.userCode" :value="item.empCode"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('testNature1')">
										<el-input v-model="projectForm.testNature" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('remark1')">
										<el-input v-model="projectForm.remark" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
            </el-card>
          </el-form>
				</el-col>
			</el-row>
		</el-tab-pane>
    <el-tab-pane name="second" :label="$t('customerInfo')">
      <el-row>
				<el-col :xs="24">
          <el-form :model="customerForm" :rules="rules" ref="customerForm" label-width="200px">
					  <el-card >
							<el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('customerName1')" prop="customerName">
										<el-input v-model="customerForm.customerName" disabled/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('csiAccountCode1')" prop="csiAccountCode">
										<el-input v-model="customerForm.csiAccountCode" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('customerIndustry1')" prop="customerIndustry">
                    <el-select filterable v-model="customerForm.customerIndustry" disabled>
											<el-option v-for="item in IndustryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subIndustry1')" >
                    <el-input v-model="customerForm.subIndustry" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('customerType1')" prop="customerType">
                    <el-select filterable v-model="customerForm.customerType" disabled>
											<el-option v-for="item in CustomerTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('customerContact1')" >
										<el-input v-model="customerForm.customerContact" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('customerMobile1')">
										<el-input v-model="customerForm.customerMobile" disabled/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('customerAddress1')">
										<el-input v-model="customerForm.customerAddress" disabled/>
									</el-form-item>
								</el-col>
              </el-row>
            </el-card>
          </el-form>
				</el-col>
			</el-row>
    </el-tab-pane>
    <el-tab-pane name="third" :label="$t('contractInfo')">
      <el-row>
				<el-col :xs="24">
          <el-form :model="contractForm" :rules="rules" ref="contractForm" label-width="210px">
					  <el-card >
							<el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceContractNo1')" >
										<el-input v-model="contractForm.serviceContractNo" disabled/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('contactVersionNo1')" >
										<el-input v-model="contractForm.contactVersionNo" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceSalesModule1')" >
                    <el-select v-model="contractForm.serviceSalesModule" disabled>
											<el-option v-for="item in ServiceSalesModuleList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceSalesType1')" >
                    <el-select v-model="contractForm.serviceSalesType" disabled>
											<el-option v-for="item in ServiceSalesTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('maintenanceStartDate1')">
										<el-date-picker v-model="contractForm.maintenanceStartDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('maintenanceEndDate1')">
										<el-date-picker v-model="contractForm.maintenanceEndDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('maintenanceContent1')" >
                    <el-input v-model="contractForm.maintenanceContent" disabled/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('amountExdudingTax1')" >
										<el-input v-model="contractForm.amountExdudingTax" disabled/>
									</el-form-item>
								</el-col>
              </el-row>
            </el-card>
          </el-form>
				</el-col>
			</el-row>
    </el-tab-pane>
    <el-tab-pane name="fourth" :label="$t('reportAttachment')">
			<!-- <el-row>
        <el-col style="margin-bottom: 10px;text-align: right;" :xs="24" :md="24">
          <el-button type="primary" size="mini" @click.prevent="downloadFile()">{{$t('download')}}</el-button>
        </el-col>
      </el-row> -->
      <el-row>
				<el-col :xs="24">
					<el-card :header="$t('taskReport')">
            <el-table :data="tableData" border @selection-change="handleSelectTask">
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column prop="fileSourceName" :label="$t('taskName')" align="center" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="fileName" :label="$t('fileName')" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <a style="color:blue;" @click="handleOpenUrl(scope.row.fileAliasName,scope.row.fileName)">{{scope.row.fileName}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="createUser" :label="$t('createUser')"  align="center" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="createTime" :label="$t('createTime')" align="center" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
            <div class="pageDiv">
              <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[5,10,20,50]"
                :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
              </el-pagination>
            </div>
					</el-card>
          <el-card :header="$t('subtaskReport')">
            <el-table :data="tableSubData" border @selection-change="handleSelectSubtask">
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column prop="fileSourceName" :label="$t('subtaskName')" align="center" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="fileName" :label="$t('fileName')" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <a style="color:blue;" @click="handleOpenUrl(scope.row.fileAliasName,scope.row.fileName)">{{scope.row.fileName}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="createUser" :label="$t('createUser')"  align="center" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="createTime" :label="$t('createTime')" align="center" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
            <div class="pageDiv">
              <el-pagination small @size-change="changeSubPageSize" @current-change="changeSubPage" :current-page="currentSubPage" :page-sizes="[5,10,20,50]"
                :page-size="pageSubSize" layout="total, prev, pager, next, sizes, jumper" :total="totalSubCount">
              </el-pagination>
            </div>
					</el-card>
				</el-col>
			</el-row>
		</el-tab-pane>
    <el-tab-pane name="fifth" :label="$t('inventory')">
      <el-row>
				<el-col :xs="24">
            <el-table :data="inventoryList" border>
              <el-table-column prop="productBom" :label="$t('productBom')" align="center" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="productName" :label="$t('productName')" align="center" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="productDesc" :label="$t('productDesc')"  align="center" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="serviceBom" :label="$t('serviceBom')" align="center" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
            <div class="pageDiv">
              <el-pagination small @size-change="changeInventoryPageSize" @current-change="changeInventoryPage" :current-page="currentInventoryPage" :page-sizes="[5,10,20,50]"
                :page-size="pageInventorySize" layout="total, prev, pager, next, sizes, jumper" :total="totalInventoryCount">
              </el-pagination>
            </div>
				</el-col>
			</el-row>
		</el-tab-pane>
    <el-row v-if="this.$route.params.showRun=='Y'">
      <el-col style="margin-top: 10px; text-align: center;" :xs="24" :md="24">
        <el-button type="primary" size="medium" @click="returnList">{{$t('return')}}</el-button>
      </el-col>
    </el-row>
	</el-tabs>
</template>
<script>
    import {_debounce} from '@/utils/selectAPI'
    import * as validate from '@/utils/validate'
    export default {
        created () {
          this.getCountry();
          this.getDeptList();
          this.getProjectTypeList();
          this.getBusinessCategoryList();
          this.getBeneficialDeptList();
          this.getIndustryList();
          this.getProjectData();
        },
        data () {
          var setDeptValue = (rule, value, callback) => {
            let userInfo = this.ProjectManagerList.find(item => {
              return item.empCode === value;
            });
            if(userInfo != null){
              this.projectForm.department = userInfo.deptCode;
            }
            callback();
          };
          let that = this;
          return {
            rangeNumber: 10,
            projectForm: {
              projectName:null,
              projectStatus:null,
              businessCategory:null,
              projectType:null,
              upstreamSystemId:null,
              ipmsProjectCode:null,
              projectManager:null,
              deputyProjectManager:null,
              department:null,
              industry:null,
              country:null,
              deliveryType:null,
              projectLevel:null,
              projectStartDate:null,
              projectEndDate:null,
              projectEstimatedEndDate:null,
              projectActualEndDate:null,
              beneficialDept:null,
              finalBeneficialDept:null,
              salesMan:null,
              salesRegion:null,
              presaleKeyProject:null,
              postsaleKeyProject:null,
              beltAndRoad:null,
              businessType:null,
              subcontractor:null,
              remark:null,
              testLeader:null,
              testNature:null,
            },
            customerForm: {
              customerName:null,
              csiAccountCode:null,
              customerIndustry:null,
              subIndustry:null,
              customerType:null,
              customerContact:null,
              customerMobile:null,
              customerAddress:null,
            },
            contractForm: {
              serviceContractNo:null,
              productContractNo:null,
              purchaseOrderNo:null,
              salesOrderNo:null,
              reseller:null,
              distributor:null,
              serviceSalesModule:null,
              serviceSalesType:null,
              firstShipmentDate:null,
              estimatedServiceStartDate:null,
              serviceDuration:null,
              maintenanceStartCondition:null,
              maintenanceStartDate:null,
              maintenanceContent:null,
              amountExdudingTax:null,
              amountWithTax:null,
              listPrice:null,
              attachServiceId:null,
              ibServiceId:null,
              orderStatus:null,
              contactVersionNo:null,
              bomCode:null,
              bomName:null,
            },
            multipleTask:[],
            multipleSubtask:[],
            tableData:[],
            currentPage: 1,
            totalCount: 0,
            pageSize: 5,
            inventoryList:[],
            currentInventoryPage: 1,
            totalInventoryCount: 0,
            pageInventorySize: 5,
            tableSubData:[],
            currentSubPage: 1,
            totalSubCount: 0,
            pageSubSize: 5,
            flagStatus:1,
            taskQty:0,
            ProjectTypeList:[],
            BusinessCategoryList:[],
            ProjectManagerList:[],
            DeputyManagerList:[],
            TestLeaderList:[],
            DeptList:[],
            DepartmentList:[],
            IndustryList:[],
            DeliveryTypeList:[
              { value: 'DirectService',label: 'DirectService'},
              { value: 'Outsource',label: 'Outsource'},
            ],
            ProjectLevelList:[
              { value: 'Normal',label: 'Normal'},
              { value: 'Department',label: 'Department'},
              { value: 'Corp',label: 'Corp'},
            ],
            BeneficialDeptList:[],
            FinalBeneficialDeptList:[],
            CountryList:[],
            BeltAndRoadList:[
              { value: 'Yes',label: 'Yes'},
              { value: 'No',label: 'No'},
            ],
            CustomerTypeList:[
              { value: 'ordinary',label: '普通客户'},
              { value: 'value',label: '价值客户'},
              { value: 'OEM',label: 'OEM客户'},
              { value: 'Agent',label: 'Agent'},
            ],
            StatusList:[
              { value: 'ToDelivered',label: 'Waiting for Delivery'},
              { value: 'Delivered',label: 'Delivering'},
              { value: 'PartialDelivery',label: 'Partially delivered'},
              { value: 'DeliveryCompleted',label: 'Fully Delivered'},
              { value: 'Frozen',label: 'Frozen'},
              { value: 'Closed',label: 'Closed'},
            ],
            PresaleKeyProjectList:[
              { value: 'Yes',label: 'Yes'},
              { value: 'No',label: 'No'},
            ],
            PostsaleKeyProjectList:[
              { value: 'Normal',label: 'Normal'},
              { value: 'Department',label: 'Department'},
              { value: 'Corp',label: 'Corp'},
            ],
            BusinessTypeList:[
              { value: 'BR',label: 'BR'},
              { value: 'RO',label: 'RO'},
              { value: 'NEC',label: 'NEC'},
              { value: 'SBR',label: 'SBR'},
              { value: 'SRO',label: 'SRO'},
              { value: 'SNEC',label: 'SNEC'},
            ],
            ServiceSalesModuleList:[
              { value: '直签',label: '直签'},
              { value: '代理商转售',label: '代理商转售'},
              { value: '代理商销售',label: '代理商销售'},
              { value: '代理商直签',label: '代理商直签'},
              { value: '商业分销',label: '商业分销'},
              { value: '直签销售',label: '直签销售'},
            ],
            ServiceSalesTypeList:[
              { value: '单独销售',label: '单独销售'},
              { value: '随项目销售',label: '随项目销售'},
            ],
            optionProps:{
              value:'deptCode',
              label:'deptEnName',
              children:[],
              lazy:true,
              lazyLoad(node, resolve){
                if(node.level > 0){
                  let url =`${that.$store.state.islhurl}dept/getDeptList`;
                  let pm = {
                    supDeptCode: node.value,
                  }
                  that._post(url,pm).then(
                    res => {
                      // leaf:node.level >= 2
                      const nodes = res.data.map(item => ({
                        deptCode:item.deptCode,
                        deptEnName:item.deptEnName,
                      }))
                      resolve(nodes)
                    }
                  )
                }
              }
            },
            rules: {
              projectName: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              projectStatus: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              projectType: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              businessCategory: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              projectManager: [
                { required: true, message: 'Please input value', trigger: 'blur' },
                { validator:setDeptValue,trigger: 'change'}
              ],
              department: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              industry: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              projectLevel: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              projectStartDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              projectEndDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              projectEstimatedEndDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              projectActualEndDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              beneficialDept: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              finalBeneficialDept: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              presaleKeyProject: [
                { required: true, message: 'Please input value', trigger: 'blur' },
              ],
              postsaleKeyProject: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              country: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              beltAndRoad: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
            }
          } 
        },
        methods: {
          getDeptList(){
            let url =`${this.$store.state.islhurl}dept/getSelectData`;
            let pm = {
              deptCodechain: 'SelectDept',
            }
            this._post(url,pm).then(
              res => {   
                this.DeptList = res.data;
              }
            )
          },
          getBeneficialDeptList(){
            let url =`${this.$store.state.islhurl}dept/getSelectData`;
            let pm = {
              deptLevel: '1',
            }
            this._post(url,pm).then(
              res => {   
                this.BeneficialDeptList = res.data;
              }
            )
          },
          getCountry(){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'Country',
            }
            this._post(url,pm).then(
              res => {   
                this.CountryList = res.data;
              }
            )
          },
          getBusinessCategoryList(){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'BusinessCategory',
            }
            this._post(url,pm).then(
              res => {   
                this.BusinessCategoryList = res.data;
              }
            )
          },
          getProjectTypeList(){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'ProjectType',
            }
            this._post(url,pm).then(
              res => {   
                this.ProjectTypeList = res.data;
              }
            )
          },
          getIndustryList(){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'Industry',
            }
            this._post(url,pm).then(
              res => {   
                this.IndustryList = res.data;
              }
            )
          },
          // selectBeneficialDept(beneficialDept){//暂不用
          //   let url =`${this.$store.state.islhurl}dept/getFinalDeptList`;
          //   let pm = {
          //     deptCode: beneficialDept,
          //   }
          //   this._post(url,pm).then(
          //     res => {   
          //       this.FinalBeneficialDeptList = res.data;
          //     }
          //   )
          // },
          //回显数据
          getProjectData(){
            let pm = {};
            let projectId = this.$route.params.projectNumber;
            if(projectId != undefined && projectId != null && projectId != ''){
              pm = {
                projectNumber: projectId,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
            }else{
              pm = {
                id: this.$route.params.id,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
            }
            let url = `${this.$store.state.islhurl}project/getInfo`
            this._post(url,pm).then(
              res =>{
                //先加载下拉选项
                setTimeout(() => {
                  const validValues = [
                    res.project.projectManager,
                    res.project.deputyProjectManager,
                    res.project.testLeader,
                  ].filter(value => value != null && value !== "");
                  if (validValues && validValues.length > 0) {
                    this.getUserList(validValues);
                  }
                }, 1500);
                //再进行赋值
                this.projectForm = res.project;
                if(res.project.beneficialDept != null){
                  this.projectForm.beneficialDept = res.project.beneficialDept.split(",")[0];
                }
                this.flagStatus = res.project.flagStatus;
                this.taskQty = res.project.taskQty;
                if(res.customer != null){
                  this.customerForm = res.customer;
                }
                if(res.contract != null){
                  this.contractForm = res.contract;
                  this.getInventoryList()
                }
                this.getTaskAttachmentList(res.project.projectNumber);
                this.getSubtaskAttachmentList(res.project.projectNumber);
              }
            )
          },
          getUserList(validValues) {
            let url =`${this.$store.state.islhurl}user/batch-get`;
            let obj = {
              empCodeList: validValues
            }
            this._post(url, obj).then(
              res => {  
                if(res.code === 200 && res.data) {
                  this.ProjectManagerList = res.data
                  this.DeputyManagerList = res.data
                  this.TestLeaderList = res.data
                }
              }
            )
          },
          handleSelectTask(val){
            this.multipleTask = val;
          },
          handleSelectSubtask(val){
            this.multipleSubtask = val;
          },
          downloadFile(){
            const leg = this.multipleTask.length;
            const lth = this.multipleSubtask.length;
            if(leg == 0 && lth == 0){
              this.$message({type:'error', showClose:true, duration:5000, message:'Please select data first'});
              return;
            }
            for (let i = 0; i < leg; i++) {
              let taskA = this.multipleTask[i];
              console.log(taskA)
              let url =`${this.$store.state.islhurl}download?fileAliasName=${taskA.fileAliasName}&fileName=${taskA.fileName}`
              window.open(url);
            }
            for (let i = 0; i < lth; i++) {
              let subtA = this.multipleSubtask[i];
              let url =`${this.$store.state.islhurl}download?fileAliasName=${subtA.fileAliasName}&fileName=${subtA.fileName}`
              window.open(url);
            }
          },
          handleOpenUrl(fileAliasName,fileName){
            let url =`${this.$store.state.islhurl}download?fileAliasName=${fileAliasName}&fileName=${fileName}`
            window.open(url);
          },
          //展示任务上传附件
          getTaskAttachmentList(projectNumber){
            let pm = {
              projectNumber: projectNumber,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            let url = `${this.$store.state.islhurl}getTaskAttachmentList/${this.pageSize}/${this.currentPage}`
            this._post(url,pm).then(
              res =>{
                this.tableData = res.data
                this.totalCount = res.totalNums
              }
            )
          },
          //展示产品清单列表
          getInventoryList(){
            let num = this.contractForm.serviceContractNo
            let pm = {}
            let url = `${this.$store.state.islhurl}getProductType/${this.pageInventorySize}/${this.currentInventoryPage}?contractNo=${num}`
            this._post(url,pm).then(
              res =>{
                this.inventoryList = res.data
                this.totalInventoryCount = res.totalNums
              }
            )
          },
          changePage (val) {
            this.currentPage = val;
            this.getTaskAttachmentList();
          },
          changePageSize (val) {
            this.pageSize = val;
            this.getTaskAttachmentList();
          },
          changeInventoryPage (val) {
            this.currentInventoryPage = val;
            this.getInventoryList();
          },
          changeInventoryPageSize (val) {
            this.pageInventorySize = val;
            this.getInventoryList();
          },
          //展示子任务上传附件
          getSubtaskAttachmentList(projectNumber){
            let pm = {
              projectNumber: projectNumber,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            let url = `${this.$store.state.islhurl}getSubtaskAttachmentList/${this.pageSubSize}/${this.currentSubPage}`
            this._post(url,pm).then(
              res =>{
                this.tableSubData = res.data
                this.totalSubCount = res.totalNums
              }
            )
          },
          changeSubPage (val) {
            this.currentSubPage = val;
            this.getSubtaskAttachmentList();
          },
          changeSubPageSize (val) {
            this.pageSubSize = val;
            this.getSubtaskAttachmentList();
          },
          addTask() {
            let pm = {
              projectNumber: this.projectForm.projectNumber,
            }
            this.$router.push({name:'task_add',params:pm})
          },
          returnList(){
            let pm = this.$route.params;
            this.$router.push({name:'project',params:pm});
          },
        },
    }
</script>


// WEBPACK FOOTER //
// src/view/project/projectDetail.vue